/**
 * Hex View Visualizer — Tool Wrapper
 *
 * Thin IVisualizerTool implementation that delegates rendering to HexView.
 * Supports inline hex editing via the standard onEdit(string) contract.
 * Edits are UTF-8 validated — invalid byte sequences are rejected.
 */

import React from 'react';

import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { IVisualizerTool, VisualizerRenderContext } from '@/interfaces/ITool';

import { HexView } from './HexView';

class HexVisualizerToolImpl implements IVisualizerTool {
  readonly id = 'hex-visualizer';
  readonly name = 'Hex View';
  readonly description = 'Hex editor — offset, hex bytes, ASCII columns with inline editing and find/replace';
  readonly version = '2.0.0';
  readonly type = 'visualizer' as const;
  readonly category = 'Visualizers';
  readonly editable = true;
  readonly keywords = ['hex', 'binary', 'bytes', 'dump', 'hexdump', 'editor', 'visualizer'];

  readonly supportedInputTypes: ISemanticType[] = [];
  readonly outputType = undefined;
  readonly attributes = [];

  supportsInput(): boolean {
    return true;
  }

  render(context: VisualizerRenderContext): React.ReactElement {
    return (
      <ErrorBoundary>
        <HexView
          data={context.input}
          editMode={context.editMode}
          onEdit={context.onEdit}
        />
      </ErrorBoundary>
    );
  }

  toText(input: string): string {
    return input;
  }
}

export const HexVisualizerTool = new HexVisualizerToolImpl();
